import { mutation_keys } from "../mutations";

/**
 * Layout action keys.
 * @type {import("../types/actions/layout").LayoutActionKeys}
 */
const layout_action_keys = {
    "UPDATE": "LAYOUT/UPDATE",
}

/**
 * Layout specific actions.
 * @type {import("../types/actions/layout").LayoutActions}
 */
const layout_actions = {
    /** Updating application layout. */
    [layout_action_keys.UPDATE]: ({ commit, state }, layout) => {
        // Getting updated layout.
        const updated_layout = Object.keys(state.layout).reduce((updated_layout, option) => {
            // Set layout option to given value or reset it to true.
            updated_layout[option] = layout[option] ?? true;
            return updated_layout;
        }, {});
        commit(mutation_keys.layout.SET, updated_layout);
    }
};

export { layout_action_keys };

export default layout_actions;